// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_uzQ","cls2":"FeedbackPopover-cls2_t6r FeedbackPopover-cls1_uzQ"};